import type { Control } from 'react-hook-form';
import { VatCostFields } from '../VatCostFields/VatCostFields';
import type { ServiceFormInput, ServiceFormOutput } from '../../schemas/service.schema';

interface ServiceCostFieldsProps {
    control: Control<ServiceFormInput, unknown, ServiceFormOutput>;
    fieldId: (field: string) => string;
    disabled: boolean;
    isTotalMode: boolean;
    /** True when this edit switches an existing total-mode service to breakdown, so any
     *  inclusions carried over from total mode reappear priced at £0. */
    convertedFromTotal?: boolean;
}

export function ServiceCostFields({ control, fieldId, disabled, isTotalMode, convertedFromTotal }: ServiceCostFieldsProps) {
    if (!isTotalMode) {
        return (
            <p className="text-sm text-mp-muted md:col-span-2">
                Cost is the sum of the service&apos;s inclusions, managed on the Items tab.
                {convertedFromTotal && ' Any items carried over from total pricing are priced at £0 — update them there.'}
            </p>
        );
    }

    return (
        <VatCostFields<ServiceFormInput>
            control={control}
            hideCategory
            netField="total_cost_net"
            grossField="total_cost_gross"
            categories={[]}
            disabled={disabled}
            fieldId={fieldId}
            labels={{ net: 'Total Cost Net (£)', gross: 'Total Cost Gross (£)' }}
        />
    );
}
